import React from "react";
import { useFormContext } from "react-hook-form";

import {
  HubHookFormInput,
  HubHookFormSelect,
  HubMaterialHookSelect,
} from "../../components";
import { StyledCell, StyledStack } from "./styles";

const LaborMaterialsTableAddRow = ({ handleAdd = () => {} }) => {
  const prefix = "addrow";

  const { getValues, setValue } = useFormContext();

  const value = {
    materialId: null,
    quantity: null,
  };

  const onFieldUpdate = (field) => {
    const value = getValues(`${prefix}.${field}`);
    handleAdd({ [field]: value });
    setValue(prefix, {});
  };

  return (
    <StyledStack sx={{ backgroundColor: "hubColors.mainFocusLighter2" }}>
      <HubMaterialHookSelect
        label={null}
        name={`${prefix}.materialId`}
        value={value.field}
        onChange={() => onFieldUpdate("materialId")}
        departmentId={4}
        required={false}
      />
      <HubHookFormInput
        name={`${prefix}.quantity`}
        value={value.format}
        onChange={() => onFieldUpdate("quantity")}
        placeholder="grams"
        required={false}
        isDecimal
      />
      <StyledCell />
    </StyledStack>
  );
};

export default LaborMaterialsTableAddRow;
